import { Dropdown } from "primereact/dropdown";
import React from "react";
import patchItem from "Services/patchItem";

const BadgeToDriver = ({ row, drivers }) => {
  const options = drivers
    ? drivers?.rows?.map((driver) => ({
        value: driver?.code,
        label: driver?.completename,
      }))
    : [];

  const badgeCode = row.code;
  const currenctDriver = row.driver ?? "";

  const handleChage = (event) => {
    const newDriver = event.value;

    const unavailableBadge = `/back/user/${currenctDriver}/badge`;

    if (event.value) {
      const url = `/back/user/${newDriver}/badge/${badgeCode}`;
      patchItem(url);
    } else patchItem(unavailableBadge);
  };

  return (
    <Dropdown
      value={currenctDriver}
      // placeholder={serialNumber}
      onChange={handleChage}
      options={options}
      optionLabel="label"
      showClear
      appendTo={document.body}
      filter
    />
  );
};

export default BadgeToDriver;
